// extracted by mini-css-extract-plugin
export default {"container":"loader_container__kscWd","spinner":"loader_spinner__IWjdW","spin":"loader_spin__2vYHb"};
    if(module.hot) {
      // 1790680669919
      var cssReload = require("/home/garphild.pro/web/drones.garphild.pro/private/nodeapp/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  